import { useFetchBondTerms } from "@portal/api/bond";
import { BondTermsCard } from "@portal/components/features/bond-terms";
import type { FC } from "react";
import type { BondPageBodyProps } from "../types";

export const AdminBondPeriodsTab: FC<BondPageBodyProps> = ({ bond }) => {
	const { terms, termsLoading } = useFetchBondTerms(bond.accountId, bond.id);

	return (
		<div data-testid="admin-bond-periods-tab">
			{!termsLoading && <BondTermsCard terms={terms} />}
		</div>
	);
};
